export const API_PATHS = {
    PROVIDERS: {
        ROOT: 'providers',
        ME: 'providers/me',
    },
    CRITERIA: 'criteria',
    CRITERIA_ZONE: 'criteria/zone',
    AUTH_LINK: 'auth-link',
    MELI: {
        PICKUP: {
            ME: 'meli/pickup/me',
        },
        DELIVERY: {
            ME: 'meli/deliveries/me',
        },
        AUTH: 'meli/auth',
        AUTH_LINK: 'meli/auth-link',
    },
    SHOPIFY: {
        PICKUP: {
            ME: 'shopify/pickup/me',
        },
        DELIVERY: {
            ME: 'shopify/deliveries/me',
        },
        AUTH: 'shopify/auth',
        AUTH_LINK: 'shopify/auth-link',
    },
    TIENDA_NUBE: {
        AUTH: 'tiendanube/auth',
        AUTH_LINK: 'tiendanube/auth-link',
        DELIVERY: {
            ME: 'tiendanube/deliveries/me',
        },
        CARRIERS: {
            ME: 'tiendanube/carriers/me',
        },
    },
    YPF: {
        ROOT: 'ypf-lp4',
        AUTH: 'ypf-lp4/auth',
        ME: 'ypf-lp4/auth/me',
    },
    GOOGLE: {
        ROOT: 'google-drive',
        AUTH: 'google-drive/auth',
        AUTH_ME: 'google-drive/auth/me',
    },
};
